import { render, staticRenderFns } from "./UserProfileEditForm.vue?vue&type=template&id=c3b15262"
import script from "./UserProfileEditForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileEditForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports